import { PageWrap, Form, Layout } from "@vwfs-bronson/bronson-react";
import { MonthlyBudget } from "../components/question-2/MonthlyBudget";
import { Deposit } from "../components/question-2/Deposit";
import { ContractMonths } from "../components/question-2/ContractMonths";
import { WizardButtons } from "../components/ui/WizardButtons";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { useTranslation } from "react-i18next";
import { getDefaultMonthlyPayment, getDepositMaxValue, getDepositMinValue } from "../data/contract";
import { IMatchMakerAnswers, Step, SubmitAnswersRequest } from "../interfaces";
import { FocusError } from "../components/generic/FocusError";
import { SaveAndContinue } from "../components/save-and-continue/SaveAndContinue";

export const Question2Page = () => {
    const { t } = useTranslation("errormessages");

    const { submitAnswersRequest, setSubmitAnswersRequest, isEdit } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;

    const SignupSchema = Yup.object().shape({
        monthlyPayment: Yup.number().required(t("errormessages:1")),
        hasDeposit: Yup.boolean(),
        deposit: Yup.number().when("hasDeposit", {
            is: true,
            then: (schema) =>
                schema
                    .min(getDepositMinValue(), t("errormessages:7", { value: getDepositMinValue() }))
                    .max(getDepositMaxValue(), t("errormessages:8", { value: getDepositMaxValue() }))
                    .required(t("errormessages:1")),
            otherwise: (schema) => schema.notRequired(),
        }),
        duration: Yup.number().required(t("errormessages:1")),
    });

    return (
        <>
            <Formik
                initialValues={
                    {
                        monthlyPayment: matchMakerAnswers?.monthlyPayment ?? getDefaultMonthlyPayment(),
                        hasDeposit: matchMakerAnswers?.hasDeposit ?? true,
                        deposit: matchMakerAnswers?.deposit ?? undefined,
                        duration: matchMakerAnswers?.duration ?? undefined,
                    } as IMatchMakerAnswers
                }
                validationSchema={SignupSchema}
                enableReinitialize={true}
                onSubmit={(values) => {
                    if (!values.hasDeposit) {
                        values.hasDeposit = false;
                        values.deposit = 0;
                    }
                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            matchMakerAnswers: {
                                ...matchMakerAnswers,
                                ...values,
                            },
                            isEditMode: isEdit,
                            currentStep: Step.MM2,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps) => (
                    <Form id="Question2PageForm" onSubmit={formikProps.handleSubmit} noValidate>
                        <Layout className="u-mt-xsmall" flush>
                            <Layout.Item>
                                <PageWrap size="small">
                                    <MonthlyBudget />
                                    <hr className="u-mv-large" />
                                    <Deposit />
                                    <hr className="u-mv-large" />
                                    <ContractMonths />
                                    <FocusError />
                                </PageWrap>
                            </Layout.Item>
                            <Layout.Item className="u-mt">
                                <WizardButtons />
                            </Layout.Item>
                        </Layout>
                    </Form>
                )}
            </Formik>
            <SaveAndContinue />
        </>
    );
};
